import { render, staticRenderFns } from "./ContentPageFooter.vue?vue&type=template&id=5c31b167"
import script from "./ContentPageFooter.vue?vue&type=script&lang=js"
export * from "./ContentPageFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports